import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useGlobalFilter, usePagination, HeaderGroup, Accessor, useSortBy, useTable } from 'react-table'
import ComponentePaginacionTabla from 'components/Varios/Tabla/ComponentePaginacionTabla';
import { GlobalFilterTable } from 'components/Varios/Tabla/GlobalFilterTable';
import ButtonDownloadReportTable from "components/Varios/Tabla/ComponentButtonExcel"
import { Container, Row, Col, Button } from 'react-bootstrap';
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import { Table } from 'reactstrap'
import { getTdTableStyles } from 'helpers/Table/tableFunctions';
import config from "config.json";
import { CustomStyleColumn } from 'components/Types/GeneralTypes';

import naranja from "assets/icons/Permisos/naranja.svg"
import verde from "assets/icons/Permisos/verde.svg"
import amarillo from "assets/icons/Permisos/amarillo.svg"
import roja from "assets/icons/Permisos/roja.svg"
import ErrorSVG from "assets/icons/Permisos/Error.svg"
import alertaROJA_TIEMPO from "assets/icons/Permisos/alertaROJA_TIEMPO.svg"
import Chek_Class from "assets/icons/Permisos/Chek_Class.svg"
import { ReactComponent as IconPdf } from "assets/icons/PDF.svg"
import ButtonAprobarMasivo from '../../Varios/ButtonAprobarMasivo';
import { downloadExcelReport } from './FunctionsHistorialVacaciones';

import 'assets/scss/popover.scss'
import 'assets/scss/SolicitudesPermisos.scss'
import * as reactTable from 'react-table';
import { HistorialSolicitudesVacacionesTH } from './TypesHistorialAprovacionesV'
import { Popover } from 'components/Admin/HistorialAprobaciones/Popover';

export default function TablaHistorialVacaciones({ dataFilas, onClickVerDocumento, onClickVerMotivo, fechaDesde, fechaHasta, estadoSolicitud, estadoAP }) {    
    const [popoverRef, setPopoverRef] = useState<any>(null);
    const [selectedRow, setSelectedRow] = useState<reactTable.Row<HistorialSolicitudesVacacionesTH> | null>(null);
    const [selectedRowDoc, setSelectedRowDoc] = useState<reactTable.Row<HistorialSolicitudesVacacionesTH> | null>(null);
    const iconRef = useRef(null);

    const [isLoading, setIsLoading] = useState(false);

    // Función para manejar la descarga del reporte y el estado de carga
    const handleDownloadReport = async () => {
        setIsLoading(true);
        try {
            await downloadExcelReport(fechaDesde, fechaHasta, estadoSolicitud, estadoAP);
        } catch (error) {
            console.error('Error al generar el reporte:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const CellDownloadPDF = (nombre: string, referencia: string | null | undefined) => {

        var estilo = referencia ? "downloaddoc" : "disableddoc"
        var textoDisponibilidad = referencia ? "" : "no disponible"
        return (
            <IconPdf
                className={estilo}
                id={`${nombre}`}
                data-toggle="tooltip"
                data-placement="top"
                title={`${nombre} ${textoDisponibilidad}`}
                style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                onClick={async () => { if (referencia) { await onClickVerDocumento(referencia) } else { ; } }}
            />
        )
    }

    const CellDocumentosDetalle = (totalrow: reactTable.Row<HistorialSolicitudesVacacionesTH>) => {
        const { original, index } = totalrow
        const row = { ...original }
        const solicitud = row.solicitud ? row.solicitud : "";

        if (solicitud !== "") {
            return (
                <div className="containerFechaDetalle" key={`containerDocumentos ${index}`}>
                    Ver documentos
                    <i ref={iconRef} onClick={(e) => {
                        e.stopPropagation();
                        setPopoverRef(e.currentTarget);
                        setSelectedRowDoc(totalrow);
                    }} className="fa fa-solid fa-ellipsis-vertical hoverable"></i>

                </div>
            );
        } else {
            return (
                <span>{solicitud}</span>
            );
        }
    }

    const CellFechaDetalle = (totalrow: reactTable.Row<HistorialSolicitudesVacacionesTH>) => {

        const { original, index } = totalrow
        const row = { ...original }
        const fecha = row.fechavth ? ObtenerFechaFromIsoFormat(row.fechavth.toString()) : "";
        const fechanega = row.fechaRechazo ? ObtenerFechaFromIsoFormat(row.fechaRechazo.toString()) : "";

        if (row.fechavth) {
            return (
                <div className="containerFechaDetalle" key={`containerFechas ${index}`}>
                    {fecha}
                    <i ref={iconRef} onClick={(e) => {
                        e.stopPropagation();
                        setPopoverRef(e.currentTarget);
                        setSelectedRow(totalrow);
                    }} className="fa fa-solid fa-ellipsis-vertical hoverable"></i>

                </div>
            );
        }
        else if (row.fechaRechazo) {
            return (
                <div className="containerFechaDetalle" key={`containerFechas ${index}`}>
                    {fechanega}
                    <i ref={iconRef} onClick={(e) => {
                        e.stopPropagation();
                        setPopoverRef(e.currentTarget);
                        setSelectedRow(totalrow);
                    }} className="fa fa-solid fa-ellipsis-vertical hoverable"></i>

                </div>
            );
        }
        else {
            return (
                <span>{fecha}</span>
            );
        }
    }    

    function GenerarCellAcciones(data) {        
        const iconoObservarComentario = (
            <span>
                <i className="fa fa-solid fa-message verDetalleHistorialSolicPer ml-2" title="Ver motivo del rechazo" onClick={() => onClickVerMotivo(data.acciones)}></i>
            </span>
        )

        const contentAccion = (
            <React.Fragment>
                {((data.acciones.motivo !== "" || data.acciones.motivo !== null) && data.acciones.estadoSolicitud === "5") && iconoObservarComentario}
            </React.Fragment>
        )
        return contentAccion
    }

    const filas = useMemo(
        () => [...dataFilas], [dataFilas]
    )

    const columnas: any = React.useMemo(
        () => [
            {
                Header: 'Fecha Solicitud',
                accessor: 'fechaSolicitud',
                Cell: ({ value }) => value !== undefined ? ObtenerFechaFromIsoFormat(value) : undefined
            },
            {
                Header: 'Tipo Solicitud',
                accessor: 'tipoSolicitud'
            },
            {
                Header: 'Identificación',
                accessor: 'identificacion'
            },
            {
                Header: 'Nombres',
                accessor: 'nombres'
            },            
            {
                Header: 'Régimen',
                accessor: 'siglasRegimen'
            },
            
            {
                Header: 'Fecha Desde',
                accessor: 'fechaInicio',
                Cell: ({ value }) => value !== undefined ? ObtenerFechaFromIsoFormat(value) : undefined
            },
            {
                Header: 'Fecha Hasta',
                accessor: 'fechaFin',
                Cell: ({ value }) => value !== undefined ? ObtenerFechaFromIsoFormat(value) : undefined
            },
            {
                Header: 'Fecha Reintegro',
                accessor: 'fechaReintegro',
                Cell: ({ value }) => value !== undefined ? ObtenerFechaFromIsoFormat(value) : undefined
            },
            {
                Header: 'Días',
                accessor: 'tiempo',
            },
            {
                Header: 'Estado solicitud',
                accessor: 'estadoParse',
            },
            {
                Header: 'Días por Aprobar',
                accessor: 'idTipoPermiso',
                Cell: ({ row }) => {
                    const solicitud = row.original;
                    const { fechaSolicitud, fechaInicio, fechaReintegro, fechaUnidad, tipoSolicitud, estadoSolicitud } = solicitud;

                    // Función para calcular días laborables
                    const addBusinessDays = (date, days) => {
                        const result = new Date(date);
                        let count = 0;
                        while (count < days) {
                            result.setDate(result.getDate() + 1);
                            if (result.getDay() !== 0 && result.getDay() !== 6) {
                                count++;
                            }
                        }
                        return result;
                    };

                    // Función modificada: NO incluye el día límite (usa "<" en lugar de "<=")
                    const getBusinessDaysBetween = (startDate, endDate) => {
                        let count = 0;
                        const current = new Date(startDate);
                        const end = new Date(endDate);

                        // Validación para evitar contar si la fecha límite ya pasó
                        if (current >= end) return 0;

                        while (current < end) { // "<" en lugar de "<=" para excluir el día límite
                            if (current.getDay() !== 0 && current.getDay() !== 6) { // Excluye fines de semana
                                count++;
                            }
                            current.setDate(current.getDate() + 1);
                        }
                        return count;
                    };

                    // Función modificada: NO incluye el día límite (usa "<" en lugar de "<=")
                    const getBusinessDaysBetweenInclude = (startDate, endDate) => {
                        let count = 0;
                        const current = new Date(startDate);
                        const end = new Date(endDate);

                        while (current <= end) {
                            if (current.getDay() !== 0 && current.getDay() !== 6) {
                                count++;
                            }
                            current.setDate(current.getDate() + 1);
                        }

                        return count;
                    };

                    try {
                        // Caso VALIDADO (mostrar check)
                        if (fechaUnidad && estadoSolicitud === "2") {
                            return (
                                <img
                                    src={Chek_Class}
                                    alt="Validado"
                                    title="Validado por la unidad"
                                    style={{ width: '30px', height: '30px' }}
                                />
                            );
                        }

                        // Si no está validado, calcular días faltantes
                        let fechaReferencia;

                        if (tipoSolicitud === "Vacaciones Planificadas") {
                            fechaReferencia = fechaInicio;
                        }
                        else if (tipoSolicitud === "Permiso Imputable a Vacaciones") {
                            fechaReferencia = fechaSolicitud;
                        }
                        else if (tipoSolicitud === "Reintegro Vacación") {
                            fechaReferencia = fechaReintegro;
                        }
                        else {
                            return ""; // No aplica para otros tipos
                        }

                        if (!fechaReferencia) return "Sin fecha";

                        const fechaLimite = new Date(fechaReferencia);
                        const fechaLimiteImputable = addBusinessDays(fechaLimite, 3);
                        const hoy = new Date();
                        hoy.setHours(0, 0, 0, 0); // Normalizar hora

                        // Caso VENCIDO (solo si está pendiente de aprobación y no es permiso imputable)
                        if (fechaLimite <= hoy && estadoSolicitud === "1" && tipoSolicitud !== "Permiso Imputable a Vacaciones") {
                            return (
                                <img
                                    src={alertaROJA_TIEMPO}
                                    alt="Vencido"
                                    title="Plazo vencido"
                                    style={{ width: '30px', height: '30px' }}
                                />
                            );
                        }
                        // Caso VENCIDO (solo si está pendiente de aprobación y es permiso imputable)
                        else if (fechaLimiteImputable < hoy && estadoSolicitud === "1" && tipoSolicitud === "Permiso Imputable a Vacaciones") {
                            return (
                                <img
                                    src={alertaROJA_TIEMPO}
                                    alt="Vencido"
                                    title="Plazo vencido"
                                    style={{ width: '30px', height: '30px' }}
                                />
                            );
                        }
                        // Caso PENDIENTE y no es PERMISO IMPUTABLE (calcular días faltantes)
                        else if (estadoSolicitud === "1" && tipoSolicitud !== "Permiso Imputable a Vacaciones") {
                            const diasFaltantes = getBusinessDaysBetween(hoy, fechaLimite);

                            // Asignar icono y tooltip según días
                            let iconoSvg, tooltipText;
                            if (diasFaltantes >= 3) {
                                iconoSvg = verde;
                                tooltipText = `${diasFaltantes} días para aprobar`;
                            } else if (diasFaltantes === 2) {
                                iconoSvg = amarillo;
                                tooltipText = "2 días para aprobar (atención)";
                            } else if (diasFaltantes === 1) {
                                iconoSvg = naranja;
                                tooltipText = "¡Último día para aprobar!";
                            } else if (diasFaltantes === 0) {
                                // Caso donde el día límite es hoy (se considera vencido)
                                return (
                                    <img
                                        src={alertaROJA_TIEMPO}
                                        alt="Vence hoy"
                                        title="Vence hoy"
                                        style={{ width: '30px', height: '30px' }}
                                    />
                                );
                            }

                            return (
                                <img
                                    src={iconoSvg}
                                    alt={`${diasFaltantes} días restantes`}
                                    title={tooltipText}
                                    style={{ width: '100px', height: '30px' }}
                                />
                            );
                        }
                        // Caso PENDIENTE y no es PERMISO IMPUTABLE (calcular días faltantes)
                        else if (estadoSolicitud === "1" && tipoSolicitud === "Permiso Imputable a Vacaciones") {
                            const diasFaltantes = getBusinessDaysBetweenInclude(hoy, fechaLimiteImputable);

                            // Estilos dinámicos según días faltantes
                            let iconoSvg, tooltipText;
                            if (diasFaltantes >= 3) {
                                iconoSvg = verde;
                                tooltipText = `${diasFaltantes} días restantes`;
                            } else if (diasFaltantes === 2) {
                                iconoSvg = amarillo;
                                tooltipText = "2 días restantes (atención)";
                            } else if (diasFaltantes === 1) {
                                iconoSvg = naranja;
                                tooltipText = "¡Último día!";
                            }

                            return (
                                <img
                                    src={iconoSvg}
                                    alt={`${diasFaltantes} días restantes`}
                                    title={tooltipText}
                                    style={{ width: '100px', height: '30px' }}
                                />
                            );
                        }
                        // Otros estados (no mostrar nada)
                        else {
                            return "";
                        }
                    } catch (error) {
                        return (
                            <img
                                src={ErrorSVG}
                                alt="Error"
                                title="Error al calcular"
                                style={{ width: '100px', height: '20px' }}
                            />
                        );
                    }
                }
            },
            {
                Header: 'Estado AP',
                accessor: 'estadoAP',
            },            
            {
                Header: 'Fechas Proceso',
                accessor: 'fechavth',
                Cell: ({ row, }) => {

                    return CellFechaDetalle(row)
                }
            },
            {
                Header: "Documentos",
                accessor: (row) => ({
                    documentos: row,
                }),
                Cell: ({ row }) => {
                    return CellDocumentosDetalle(row)
                }
            },
            {
                Header: "Observaciones",
                accessor: (row) => ({
                    acciones: row,
                }),
                Cell: ({ value }) => GenerarCellAcciones(value)
            },
        ], [dataFilas]
    )

    const columnasStyles = (cell): Array<CustomStyleColumn> => [
        {
            HeaderName: 'Identificación',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Fecha Solicitud',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Fecha Desde',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Fecha Hasta',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Fecha Reintegro',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Días',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Estado solicitud',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Días por Aprobar',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Estado AP',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Fechas Proceso',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Documentos',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Observaciones',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Grado",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "RMU",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "# Partida",
            StyleHeader: {
                textAlign: "center"
            }
        }
    ]

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        setPageSize,
        visibleColumns,
        prepareRow,
        state,
        setGlobalFilter
    } = useTable(
        {
            columns: columnas,
            data: filas
        },
        useGlobalFilter,
        useSortBy,
        usePagination
        )

    const { globalFilter, pageIndex, pageSize } = state;
    const sizerows = filas.length;

    const closePopover = () => {
        setPopoverRef(null);
        setSelectedRow(null);
    };

    const closePopoverDocumento = () => {
        setPopoverRef(null);
        setSelectedRowDoc(null);
    };

    const PopOverFecha = (row: HistorialSolicitudesVacacionesTH) => {
        // Datos organizados en un array para mejor manejo
        const items = [
            {
                label: 'Aprob. Directivo',
                fecha: row.fechaUnidad,
                nombre: row.directivo,
                condition: !!row.fechaUnidad
            },            
            {
                label: 'Elab./Validación AP',
                fecha: row.fechavth,
                nombre: row.analista,
                condition: !!row.fechavth
            },
            {
                label: 'Revisión AP',
                fecha: row.fechaRevision,
                nombre: row.revision,
                condition: !!row.fechaRevision
            },
            {
                label: 'Delegado TH',
                fecha: row.fechanominath,
                nombre: row.nominaTH,
                condition: !!row.fechanominath
            },
            {
                label: 'Delegado Max. Aut.',
                fecha: row.fechaDelegadoMaxAutoridad,
                nombre: row.delegadoMaxAutoridad,
                condition: !!row.fechaDelegadoMaxAutoridad
            },
            {
                label: 'Registrado AP',
                fecha: row.fechaRegistro,
                nombre: row.registro,
                condition: !!row.fechaRegistro
            },
            {
                label: 'Notif. AP',
                fecha: row.fechaNotificacion,
                nombre: row.notificacion,
                condition: !!row.fechaNotificacion
            },
            {
                label: 'Negada TH',
                fecha: row.fechaRechazo,
                nombre: row.analistaRechazo,
                condition: !!row.fechaRechazo
            },
            // ... añadir el resto de los items de la misma forma
        ];

        return (
            <ul className="listadoPopOver">
                {items.map((item, index) => (
                    (item.condition === undefined || item.condition) && (
                        <li key={index}>
                            <span>{item.label}</span>
                            <span>{item.fecha ? ObtenerFechaFromIsoFormat(item.fecha.toString()) : ""}</span>
                            <span>{item.nombre || ""}</span>
                        </li>
                    )
                ))}
            </ul>
        );
    };

    const PopOverDocumento = (data: HistorialSolicitudesVacacionesTH) => {
        // Organizamos los documentos en un array para mejor manejo
        const documentos = [
            { label: 'Solicitud', referencia: data.solicitud },
            { label: 'Acción de Personal', referencia: data.accionPersonal }
            // Puedes añadir más documentos aquí si es necesario
        ];

        return (
            <ul className="listadoPopOverDocs">
                {documentos.map((doc, index) => (
                    doc.referencia && (
                        <li key={index}>
                            <span>{doc.label}</span>
                            <span>{CellDownloadPDF(doc.label, doc.referencia)}</span>
                        </li>
                    )
                ))}
            </ul>
        );
    };

    return (
        <React.Fragment>
            <Row>
                <Col xl={12}>
                    <div className="containerBtnAprobacionesVacLic">
                        <GlobalFilterTable
                            filter={globalFilter}
                            setFilter={setGlobalFilter}
                        />
                        <div className='containerBotonGenerarReporte'>
                            <ButtonAprobarMasivo
                                onClick={handleDownloadReport}
                                text={isLoading ? "Cargando..." : "GENERAR REPORTE"}
                                disabled={isLoading}
                            />
                        </div>
                    </div>
                </Col>
            </Row>            
            <Row>
                <Col xl={12}>
                    <Table responsive {...getTableProps()} style={{ border: 'solid 1px ' }} className="tablesReact" >
                        <thead style={{}}>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                            className='clickable'
                                        >
                                            {column.render('Header')}
                                            <span>
                                                {column.isSorted ? (column.isSortedDesc ? '⬆️' : '⬇️') : ''}
                                            </span>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map((row, indirow) => {
                                prepareRow(row)
                                return (
                                    <tr {...row.getRowProps()}>
                                        {row.cells.map(cell => {
                                            return getTdTableStyles(cell, { border: 'solid 1px black' }, indirow, columnasStyles(cell))
                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                    <ComponentePaginacionTabla
                        page={page}
                        sizerows={sizerows}
                        canNextPage={canNextPage}
                        canPreviousPage={canPreviousPage}
                        nextPage={nextPage}
                        pageIndex={pageIndex}
                        pageOptions={pageOptions}
                        pageSize={pageSize}
                        previousPage={previousPage}
                        setPageSize={setPageSize}
                    />
                </Col>
            </Row>

            {popoverRef && selectedRow && (
                <Popover referenceElement={popoverRef} onClose={closePopover}>
                    <div className={"arrowStyle"}></div> {/* Esta es la punta */}
                    {PopOverFecha(selectedRow.original)}

                </Popover>
            )}

            {popoverRef && selectedRowDoc && (
                <Popover referenceElement={popoverRef} onClose={closePopoverDocumento}>
                    <div className={"arrowStyle"}></div> {/* Esta es la punta */}
                    {PopOverDocumento(selectedRowDoc.original)}

                </Popover>
            )}
        </React.Fragment>
    )
}